import { useEffect, useState } from 'react';

/** Rows drawn at once on opening a long list. */
export const PROGRESSIVE_FIRST = 25;
const PROGRESSIVE_STEP = 40;

/**
 * How many rows of a long list to draw now. The first screen comes at once,
 * the rest a batch per frame, so opening 200 matches does not stop the page.
 */
export function useProgressiveCount(total: number): number {
  const [shown, setShown] = useState(PROGRESSIVE_FIRST);

  useEffect(() => {
    if (shown >= total) return;
    const frame = window.requestAnimationFrame(() =>
      setShown((n) => n + PROGRESSIVE_STEP)
    );
    return () => window.cancelAnimationFrame(frame);
  }, [shown, total]);

  return Math.min(shown, total);
}
